import React,{useState,useEffect} from 'react';
import SurveyComp from '../components/SurveyComp'

export default function SampleSurvey() {
    return <SurveyComp mode='' />
}
